import styled from "styled-components";

const MyDiv = styled.div`
.card_wrapper {
  border-radius: 12px;
  overflow: hidden;
  background: white;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
}
  
.badgeId{
  background: #f5f5f5;
  font-size: 9px;
  color: #555;
  border-radius: 16px;
  padding: 2px 8px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.badgeDegi{
  background: #e6f0ff;
  font-size: 10px;
  color: #007AFF;
  border-radius: 8px;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.background .bg_img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}
.profile_section {
  padding: 0 9px;
  margin-top: -30px;
  display: flex;
  gap: 12px;
}
.info_box {
  flex: 1;
  margin-top: 8px;
}
.status_dropdown {
  width: 80px;
  height: 26px;
  font-size: 12px;
  border-radius: 6px;
  background-color: #f0fdf4;
  color: #22c55e;
}
.emp_code {
  background: #f5f5f5;
  font-size: 10px;
  color: #555;
  border-radius: 12px;
  padding: 2px 8px;
}
.designation {
  background: #e6f0ff;
  font-size: 10px;
  color: #007aff;
  border-radius: 4px;
  padding: 2px 6px;
}
.info_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 20px;
  column-gap: 35px;
}
.overview_card {
  border-radius: 10px;
  padding: 12px;
  margin-top: 10px;
}
.green {
  background-color: #D0FAE6;
}
.orange {
  background-color:#FFEED4;
}
.history_btn {
  border: 0.5px solid #000000;
  border-radius: 22px;
  padding: 8px 16px;
  background: #f9f9f9;
}
`;

export default MyDiv;
